import { createRouteRef } from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();

export const clustersListRouteRef = createRouteRef();

export const clusterDetailRouteRef = createRouteRef({
  params: ['neo4jClusterId'],
});

export const databaseDetailRouteRef = createRouteRef({
  params: ['neo4jDatabaseId'],
});

export const serverDetailRouteRef = createRouteRef({
  params: ['serverId'],
});

export const auraOperationsRouteRef = createRouteRef();
